<template>
    <yams-template>
        <template #header>
            <div class="mr-5">
                <h4 class="text-primary">Configurations</h4>
            </div>
        </template>
        <template #content>
            <div class="container">

                <div class="row">
                    <div class="col-md-4">
                        <div class="card card-body p-1">
                            <ul class="list-group list-group-flush">
                                <li class="list-group-item">
                                    <router-link :to="{ name: 'configurations.general' }">
                                        <i class="fa-solid fa-sliders mr-2"></i>
                                        <span>Configuration générale</span>
                                    </router-link>
                                </li>
                                <li class="list-group-item ">
                                    <router-link :to="{ name: 'configurations.vehicules' }">
                                        <i class="fa-solid fa-truck mr-2"></i>
                                        <span>Parametres des vehicules</span>
                                    </router-link>
                                </li>
                                <li class="list-group-item ">
                                    <router-link :to="{ name: 'configurations.interventions' }">
                                        <i class="fa-solid fa-wrench mr-2"></i>
                                        <span>Parametres des interventions</span>
                                    </router-link>
                                </li>
                                <li class="list-group-item ">
                                    <router-link :to="{ name: 'configurations.courses' }">
                                        <i class="fa-solid fa-road-bridge mr-2"></i>
                                        <span>Parametres des courses</span>
                                    </router-link>
                                </li>
                                <!-- <li class="list-group-item">
                                    <router-link to="">
                                        <i class="fa-solid fa-receipt mr-2"></i>
                                        <span>Parametres des comptes</span>
                                    </router-link>
                                </li> -->
                            </ul>
                        </div>
                    </div>
                    <div class="col-md-8">
                        <div class="card card-body">
                            <slot name="config_content"></slot>
                        </div>
                    </div>
                </div>

            </div>
        </template>
    </yams-template>
</template>


<script>
import { defineComponent, defineAsyncComponent } from 'vue';

export default defineComponent({
    name: 'IndexConfig',
    data() {
        return {

        }
    },
});
</script>
